export default class Paciente {
    constructor() {
        this.nrProcesso = null,
        this.solicitacaoId = null,
        this.paciente = {
            idMitra: null,
            idCadSUS: null,
            idCM: null,
            nome: null,
            nomeMae: null,
            nomePai: null,
            cnsList: [],
            cpf: null,
            racaPaciente: null,
            nascimento: null,
            sexo: null,
            pacienteId: null,
            cnesUnidade: null,
            logradouro: null,
            codigoTipoLogradouro: null,
            bairro: null,
            numero: null,
            complemento: null,
            cep: null,
            codigoIBGEMunicipio: null,
            nomeMunicipio: null,
            ufEstado: null,
            telefone: null,
            telefoneCelular: null,
            telefoneSecundario: null,
            telefoneCelularSecundario: null,
            email: null,
            codigoPaisOrigem: null,
            codigoIBGEMunicipioOrigem: null,
            nacionalidade: null,
            naturalidade: null,
            obito: null
        },
        this.numeroCNSPaciente = null,
        this.data = null,
        this.estado = null,
        this.tipo = null,
        this.centralRegulacaoResponsavel = {
            id: null,
            descricao: null,
            tipo: null,
            codigoExterno: null,
            codigoIbgeMunicipio: null,
            aliasProvedorIntegracao: null
        },
        this.justificativa = null,
        this.especialidade = {
            key: null,
            value: null,
            exclusivoUnidadeReferenciada: null,
            teleconsulta: null
        },
        this.caraterInternacao = null,
        this.codigoProcedimento = null,
        this.tipoDeLeito = {
            key: null,
            value: null,
            id: null,
            descricao: null
        },
        this.idServicoRede = null,
        this.urlTeleconsulta = null,
        this.aliasProvedor = null
    }
}
